import { Link } from 'react-router-dom';
import { heroArticle } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroArticle.image}
          alt="吃瓜网官网 - 最新热门爆料"
          title="吃瓜网官网每日爆料头条"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 pt-20 md:pt-24 pb-12 md:pb-16">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-start gap-8 md:gap-12">
          <div className="w-full lg:w-[42%] flex flex-col">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-primary-500/90 text-background-50 backdrop-blur-sm mb-4 md:mb-5 whitespace-nowrap">
              {heroArticle.tag}
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4 md:mb-5">
              {heroArticle.title}
            </h1>
            <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-6 md:mb-8">
              {heroArticle.summary}
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={`/article/${heroArticle.id}`}
                className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                阅读全文
              </Link>
              <Link
                to="/category/meiri-baoliao"
                className="px-6 py-3 rounded-lg border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                更多爆料
              </Link>
            </div>
          </div>

          <div className="w-full lg:w-[58%] mt-6 lg:mt-0">
            <div className="relative rounded-2xl overflow-hidden aspect-[16/10] md:aspect-[16/9]">
              <img
                src={heroArticle.image}
                alt={heroArticle.title}
                title={heroArticle.title}
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 bg-gradient-to-t from-black/70 to-transparent">
                <div className="flex items-center gap-3 text-background-50/80 text-xs md:text-sm">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {heroArticle.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {heroArticle.author}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}